import restaurantsApi from '../../api/restaurants-api';

const restaurants = {
    items: [],
    item: {},
    listSelect: [],
    listSelectTypes: [],
    listSelectProfiles: [],
    listSelectLanguages: [],
    createdFailed: false,
    restaurantsUser: [],
    currentRestaurant: 0,
    latitudeCalculate: '',
    longitudeCalculate: '',
    reportUrl: '',
    popupAllowFidelization: false

};

const mutations = {
    recoverRestaurantsUser(state) {
        const recoveredUser = JSON.parse(localStorage.getItem('user'));
        if (!recoveredUser) {
            state.restaurantsUser = null;
        } else {
            state.restaurantsUser = recoveredUser.restaurants;
        }
    },
    recoverCurrentRestaurant(state) {
        const currentRestaurant = JSON.parse(localStorage.getItem('currentRestaurant'));
        if (!currentRestaurant) {
            state.currentRestaurant = null;
        } else {
            state.currentRestaurant = currentRestaurant;
        }
    },
    setCurrentRestaurant(state, payload) {
        state.currentRestaurant = payload;
        localStorage.setItem('currentRestaurant', JSON.stringify(state.currentRestaurant));
    },
    setItemsRestaurants(state, payload) {
        state.items = payload.data;
    },
    setItemRestaurant(state, payload) {
        state.item = payload;
    },
    setSelectRestaurant(state, payload) {
        state.listSelect = payload.data;
    },
    setSelectTypesRestaurant(state, payload) {
        state.listSelectTypes = payload.data;
    },
    setSelectProfilesRestaurant(state, payload) {
        state.listSelectProfiles = payload.data;
    },
    setSelectLanguagesRestaurant(state, payload) {
        state.listSelectLanguages = payload.data;
    },
    setCoordinatesLat(state, payload) {
        state.latitudeCalculate = payload;
    },
    setCoordinatesLng(state, payload) {
        state.longitudeCalculate = payload;
    },
    setUrl(state, payload) {
        state.reportUrl = payload;
    },
    setpopupAllowFidelization(state, payload) {
        state.popupAllowFidelization = payload;
    },
};

const actions = {
    async refreshRestaurants(context, language) {
        const res = await restaurantsApi.getAll(language);
        context.commit('setItemsRestaurants', res.data);
    },
    async getRestaurant(context, { id, language }) {
        context.commit('setItemRestaurant', {});
        const res = await restaurantsApi.getOne(id, language);
        context.commit('setItemRestaurant', res.data.data);
    },
    calculateCoordinates({ commit, dispatch }, { country, address, postalCode }) {
        commit('loading', true);
        restaurantsApi.calculateCoordinates(country, address, postalCode).then(
            (response) => {
                commit('loading', false);
                commit('setCoordinatesLat', response.data[0].lat);
                commit('setCoordinatesLng', response.data[0].lng);
                commit('notifications', { title: 'Latitud y longitud calculadas' });
                commit('showNotifications', true);
            },
            (error) => {
                commit('loading', false);
                if (error.response.status === 400) {
                    commit('notifications', { title: error.response.data.message, color: 'danger' });
                    commit('showNotifications', true);
                }
            },
        );
    },
    async getRestaurantPublic(context, { slug, language }) {
        const res = await restaurantsApi.getOnePublic(slug, language);
        context.commit('setItemRestaurant', res.data.data);
    },
    async getAllRestaurantsForSelect(context, language) {
        const res = await restaurantsApi.getAllForSelect(language);
        context.commit('setSelectRestaurant', res);
    },
    async getAllTypesRestaurantForSelect(context, language) {
        const res = await restaurantsApi.getAllTypesForSelect(language);
        context.commit('setSelectTypesRestaurant', res);
    },
    async getAllProfilesRestaurantForSelect(context, language) {
        const res = await restaurantsApi.getAllProfilesForSelect(language);
        context.commit('setSelectProfilesRestaurant', res);
    },
    async getAllLanguagesRestaurantForSelect(context, language) {
        const res = await restaurantsApi.getAllLanguagesForSelect(language);
        context.commit('setSelectLanguagesRestaurant', res);
    },

    async submitInfo({ commit, dispatch }, { formData }) {
        commit('loading', true);
        restaurantsApi.submitInfo(formData).then(
            (response) => {
                commit('loading', false);
                dispatch('refreshCompanies');
                commit('notifications', { title: 'fidelization.LoyaltyUpdateOk' });
                commit('showNotifications', true);
            },
            (error) => {
                commit('loading', false);
                commit('notifications', { title: 'fidelization.LoyaltyUpdateFail', color: 'danger' });
            },
        );
    },

    createRestaurant({ commit, dispatch }, { restaurant, language }) {
        commit('loading', true);
        restaurantsApi.create(restaurant, language).then(
            (response) => {
                commit('loading', false);
                dispatch('refreshCompanies');
                commit('notifications', { title: 'restaurant.RestauranteCreado' });
                commit('showNotifications', true);
            },
            (error) => {
                commit('loading', false);
                commit('notifications', { title: 'restaurant.NotRestauranteCreado', color: 'danger' });
            },
        );
    },

    async getReport(context, { id, language }) {
        context.commit('loading', true);
        context.commit('setUrl', {});
        restaurantsApi.downloadReport(id, language).then(
            (response) => {
                context.commit('setUrl', response.data);
                context.commit('loading', false);
            },
            (error) => {
                context.commit('loading', false);
            },
        );
    },
    editRestaurant({ commit, dispatch }, { id, restaurant, language, newLanguage }) {
        commit('loading', true);
        restaurantsApi.edit(id, restaurant, language).then(
            (response) => {
                restaurantsApi.getAllByUser(language).then((reponseAll) => {
                    commit('restaurantsUser', reponseAll.data);
                    commit('notifications', { title: 'restaurant.RestauranteEditado' });
                    if (newLanguage !== language) {
                        commit('loading', false);
                        commit('showNotifications', true);
                        dispatch('getRestaurant', { id, language: newLanguage });
                    } else {
                        location.href = '/admin/restaurant';
                    }
                });
            },
            (error) => {
                commit('loading', false);
                commit('notifications', { title: 'restaurant.NotRestauranteEditado', color: 'danger' });
                commit('showNotifications', true);
            },
        );
    },
};

const getters = {
    getRestaurants: (state) => state.items,
    getRestaurant: (state) => state.item,
    restaurantsListSelect: (state) => state.listSelect,
    getListTypeRestaurant: (state) => state.listSelectTypes,
    getListProfileRestaurant: (state) => state.listSelectProfiles,
    getListLanguagesRestaurant: (state) => state.listSelectLanguages,
    getCurrentRestaurant: (state) => state.currentRestaurant,
    getRestaurantsUser: (state) => state.restaurantsUser,
    getLatitudeCalculate: (state) => state.latitudeCalculate,
    getLongitudeCalculate: (state) => state.longitudeCalculate,
    getReport: (state) => state.reportUrl,
    getpopupAllowFidelization: state => state.popupAllowFidelization,
};

export default {
    state: restaurants,
    mutations,
    actions,
    getters,
};
